import { jsx as _jsx } from "react/jsx-runtime";
import { mergeStyles } from '@fluentui/react';
import { transition } from '../theme/styles/shared';
/** Component used by theme provider which takes up the whole page and provides:
 * - Default scroll behavior
 * - Theme-driven background & text color
 * - Overrides for some built-in styles to make them theme-compliant
 *
 * > Note: don't use the theme provider to set the size of the page.
 * > If you want fullpage, set the page size on one of its parents.
 * > This is to enable cases where a small part of the page can have
 * > its own theme.
 */
export const ThemeProviderBackground = ({ children, isTransitioning, }) => {
    const transitionStyle = isTransitioning
        ? {
            transition,
            div: {
                transition,
                '-webkit-transition': transition,
            },
        }
        : {};
    //converts the FluentUI style to a vanilla CSS class
    const className = mergeStyles({
        height: '100%',
    }, transitionStyle);
    return _jsx("div", { className: className, children: children });
};
